import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";

import { Box } from "@mui/material";

import TabsField from "components/Tab";
import Banner from "components/Banner";
import MainCard from "components/cards/MainCard";
import Loader from "components/Loader";
import useZustandStore from "zustandStore";

import Overview from "./Overview";
import ServiceExperience from "./ServiceExperience";
import Security from "./Security";
import Roam from "./Roam";
import WirelessCoverage from "./WirelessCoverage";
import LinkIntegrity from "./LinkIntegrity";
import Operations from "./Operations";

import { ReactComponent as DisplayCalendarIcon } from "assets/images/icons/icn_display_calendar.svg";

const tabData = [
  {
    name: "Overview",
    value: "overview",
    disabled: null,
  },
  {
    name: "Service Experience",
    value: "service_experience",
    disabled: null,
  },
  {
    name: "Security",
    value: "security",
    disabled: null,
  },
  {
    name: "Roam",
    value: "roam",
    disabled: null,
  },
  {
    name: "Wireless Coverage",
    value: "wireless_coverage",
    disabled: null,
  },
  {
    name: "Link Integrity",
    value: "link_integrity",
    disabled: null,
  },
  {
    name: "Operations",
    value: "operations",
    disabled: null,
  },
];

const AInsight = () => {
  const { scopeReady } = useOutletContext();
  const serviceStatus = useZustandStore((state) => state.serviceStatus);
  const isUnityProSubscribed = serviceStatus?.services?.unityPro === true;
  const [tabVal, setTabVal] = useState("overview");
  const [timeRange, setTimeRange] = useState("Last 7 Days");

  if (!scopeReady || !serviceStatus) return <Loader />;

  function handleTab(_event, newValue) {
    setTabVal(newValue);
  };

  const aInsightFieldMap = {
    overview: (
      <Overview
        timeRange={timeRange}
        handleTab={handleTab}
        licenseStatus={serviceStatus}
      />
    ),
    service_experience: <ServiceExperience />,
    security: <Security isUnityProSubscribed={isUnityProSubscribed} />,
    roam: <Roam />,
    wireless_coverage: <WirelessCoverage />,
    link_integrity: (
      <LinkIntegrity isUnityProSubscribed={isUnityProSubscribed} />
    ),
    operations: <Operations />,
  };

  return (
    <>
      {/* <Box sx={{ display: "flex", alignItems: "center", position: "absolute", top: "10px", right: "25px" }}>
        <DisplayCalendarIcon />
        <Typography sx={{ marginLeft: "5px" }}>{timeRange}</Typography>
      </Box> */}
      <MainCard>
        {!isUnityProSubscribed && (
          <Box sx={{ mt: "20px", mb: "20px" }}>
            <Banner
              color='yellow'
              text='Health AI Insight is a Nuclias Unity Pro feature. Please subscribe to Nuclias Unity Pro to view insights.'
            />
          </Box>
        )}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <TabsField
            tabVal={tabVal}
            handleTabsChange={handleTab}
            tabData={tabData}
          />
        </Box>
        <Box sx={{ margin: "20px 20px" }}>
          {aInsightFieldMap[tabVal]}
        </Box>
      </MainCard>
    </>
  );
};

export default AInsight;
